import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const displayedArticles = articles;

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Artykuły i Poradniki
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mt-2">
              Przewodniki i analizy o USFans Spreadsheet
            </p>
          </div>
          <Link
            to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
            className="text-sm font-semibold text-accent-600 hover:text-accent-500 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            Zobacz wszystkie
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {displayedArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden transition-all hover:scale-[1.02] flex flex-col"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                {idx === 0 && (
                  <span className="absolute top-3 left-3 text-xs font-semibold text-background-50 bg-accent-500 px-2.5 py-1 rounded-full whitespace-nowrap">
                    Polecane
                  </span>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-time-line text-[10px]"></i>
                    </span>
                    {article.readingTime}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 leading-snug line-clamp-2">{article.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">{article.desc}</p>
                <span className="inline-flex items-center text-xs font-semibold text-accent-600 group-hover:text-accent-500 transition-colors whitespace-nowrap mt-auto">
                  Czytaj więcej
                  <span className="w-3.5 h-3.5 flex items-center justify-center ml-1">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}